import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToInquiry = () => {
    document.getElementById('inquiry')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? 'py-4 bg-black/80 backdrop-blur-md border-b border-white/10' : 'py-6 bg-transparent'}`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <div className="flex items-center gap-2 group cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-lg shadow-indigo-500/20 group-hover:scale-110 transition-transform">
            <span className="text-white font-black text-xl">K</span>
          </div>
          <span className="font-bold text-2xl tracking-tighter text-white">Kuhako<span className="text-indigo-400">.pro</span></span>
        </div>

        <div className="hidden md:flex items-center gap-10 text-sm font-semibold text-slate-400">
          <a href="#how-it-works" className="hover:text-white transition-colors">How It Works</a>
          <a href="#events" className="hover:text-white transition-colors">Solutions</a>
          <a href="#features" className="hover:text-white transition-colors">Technology</a>
        </div>

        <button 
          onClick={scrollToInquiry}
          className="bg-white text-black px-6 py-2.5 rounded-full text-sm font-bold hover:bg-indigo-500 hover:text-white transition-all active:scale-95 shadow-lg shadow-white/5"
        >
          Request Access
        </button>
      </div>
    </motion.nav>
  );
}